/* Bi-Color-Konfigurator (B2C) — Harbour PDP, Dawn 15.4.1

   Nutzt Dawns bestehende Variant-Logik: im Bi-Color-Modus wird das versteckte
   Farbe-Radio "Bi-Color individuell" auf checked gesetzt und ein bubbelndes
   change-Event ausgelöst. <variant-selects> (global.js) publiziert daraufhin
   option-value-selection-change, <product-info> rendert die Section neu und
   setzt Preis (Basis + 40 €), Verfügbarkeit und Media selbst. KEIN eigener
   Preis-Code.

   Zuständigkeiten hier:
   - "Bi-Color individuell" nie als Swatch zeigen (beide Modi)
   - Modus-Umschaltung Einfarbig | Bi-Color
   - Farb-Swatches im Bi-Color-Modus ausblenden (Bügelmaterial/Glasgröße bleiben)
   - properties[Obere/Untere Farbe] füllen/disablen
   - Validierung (beide Codes gültig) → In-den-Warenkorb an/aus
   - zweizonige 194-Vorschau ansteuern (color-preview-194)
*/
(function () {
  if (window.customElements.get('bicolor-config')) return;

  class BicolorConfig extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.bicolorValue = this.dataset.bicolorValue || 'Bi-Color individuell';
      this.mode = 'single';
      this.savedSingleValue = '';

      this.productInfo = this.closest('product-info');
      this.panel = this.querySelector('[data-bicolor-panel]');
      this.warnEl = this.querySelector('[data-bicolor-warn]');
      this.segButtons = Array.from(this.querySelectorAll('.bicolor__seg-btn'));
      this.datalist = this.querySelector('datalist');
      this.inputs = {
        top: this.querySelector('[data-bicolor-input="top"]'),
        bottom: this.querySelector('[data-bicolor-input="bottom"]'),
      };
      this.chips = {
        top: this.querySelector('[data-bicolor-chip="top"]'),
        bottom: this.querySelector('[data-bicolor-chip="bottom"]'),
      };
      this.props = {
        top: this.querySelector('[data-bicolor-prop="top"]'),
        bottom: this.querySelector('[data-bicolor-prop="bottom"]'),
      };
      this.singleNote = this.querySelector('[data-bicolor-single-note]');
      this.swatchWraps = {
        top: this.querySelector('[data-bicolor-swatches="top"]'),
        bottom: this.querySelector('[data-bicolor-swatches="bottom"]'),
      };

      this.buildValidSet();

      // "Bi-Color individuell" nie als Swatch anzeigen (auch im Einfarbig-Modus)
      this.hideBicolorSwatch();

      // aktuelle Einfarbig-Auswahl merken (für Rückkehr aus Bi-Color)
      this.captureSingleValue();

      // Events
      this.segButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.setMode(btn.dataset.mode, true));
      });
      ['top', 'bottom'].forEach((k) => {
        if (this.inputs[k]) this.inputs[k].addEventListener('input', () => this.updateFromInputs());
      });
      ['top', 'bottom'].forEach((k) => {
        var wrap = this.swatchWraps[k];
        if (!wrap) return;
        wrap.addEventListener('click', (e) => {
          var btn = e.target.closest('.bicolor__swatch');
          if (!btn) return;
          this.inputs[k].value = btn.dataset.code;
          this.updateFromInputs();
        });
      });

      // Nach jedem Variantenwechsel wird <variant-selects> neu gerendert →
      // Swatch-Verstecken, Fieldset-Sichtbarkeit und Validierung erneut anwenden.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this._unsub = subscribe(PUB_SUB_EVENTS.variantChange, () => {
          this.hideBicolorSwatch();
          this.applyColorFieldsetVisibility();
          if (this.mode === 'single') this.captureSingleValue();
          this.applyValidation();
        });
      }

      // Startzustand
      this.setMode('single', false);
    }

    disconnectedCallback() {
      if (this._unsub) this._unsub();
    }

    /* ----- Helpers: variant-selects / radios ----- */

    get variantSelects() {
      return (this.productInfo || document).querySelector('variant-selects');
    }

    allColorRadios() {
      var vs = this.variantSelects;
      if (!vs) return [];
      return Array.from(vs.querySelectorAll('input[type="radio"]'));
    }

    findBicolorRadio() {
      var self = this;
      return this.allColorRadios().find(function (i) {
        return i.value === self.bicolorValue;
      }) || null;
    }

    findRadioByValue(value) {
      if (!value) return null;
      var v = String(value).toLowerCase();
      return this.allColorRadios().find(function (i) {
        return i.value.toLowerCase() === v;
      }) || null;
    }

    colorFieldset() {
      var radio = this.findBicolorRadio();
      return radio ? radio.closest('fieldset') : null;
    }

    /* ----- Swatch verstecken ----- */

    hideBicolorSwatch() {
      var radio = this.findBicolorRadio();
      if (!radio) return;
      radio.style.display = 'none';
      var vs = this.variantSelects;
      var label = vs && vs.querySelector('label[for="' + radio.id + '"]');
      if (label) label.style.display = 'none';
    }

    /* ----- Einfarbig-Wert merken ----- */

    captureSingleValue() {
      var self = this;
      var checked = this.allColorRadios().find(function (i) {
        return i.checked && i.value !== self.bicolorValue;
      });
      if (checked) {
        this.savedSingleValue = checked.value;
      } else if (!this.savedSingleValue) {
        var first = this.allColorRadios().find(function (i) {
          return i.value !== self.bicolorValue;
        });
        if (first) this.savedSingleValue = first.value;
      }
    }

    /* ----- Variante über Dawn treiben ----- */

    driveRadio(radio) {
      if (!radio || radio.checked) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    selectBicolorVariant() {
      this.driveRadio(this.findBicolorRadio());
    }

    selectSingleVariant() {
      var radio = this.findRadioByValue(this.savedSingleValue);
      if (!radio) {
        var self = this;
        radio = this.allColorRadios().find(function (i) {
          return i.value !== self.bicolorValue;
        });
      }
      this.driveRadio(radio);
    }

    /* ----- Modus ----- */

    setMode(mode, drive) {
      this.mode = mode === 'bi' ? 'bi' : 'single';
      var bi = this.mode === 'bi';

      this.segButtons.forEach(function (b) {
        b.setAttribute('aria-selected', String(b.dataset.mode === (bi ? 'bi' : 'single')));
      });
      if (this.panel) this.panel.hidden = !bi;
      if (this.singleNote) this.singleNote.hidden = bi;

      this.applyColorFieldsetVisibility();
      this.setPropsEnabled(bi);

      if (drive) {
        if (bi) {
          this.captureSingleValue();
          this.selectBicolorVariant();
        } else {
          this.selectSingleVariant();
        }
      }

      this.updateFromInputs();
    }

    applyColorFieldsetVisibility() {
      var fs = this.colorFieldset();
      if (!fs) return;
      if (this.mode === 'bi') {
        fs.hidden = true;
        fs.style.setProperty('display', 'none', 'important');
      } else {
        fs.hidden = false;
        fs.style.removeProperty('display');
      }
    }

    /* ----- Properties ----- */

    setPropsEnabled(enabled) {
      ['top', 'bottom'].forEach((k) => {
        var p = this.props[k];
        if (!p) return;
        if (enabled) {
          p.removeAttribute('disabled');
        } else {
          p.setAttribute('disabled', 'disabled');
          p.value = '';
        }
      });
    }

    updateProps() {
      if (this.mode !== 'bi') return;
      if (this.props.top) this.props.top.value = this.canonical(this.inputs.top.value);
      if (this.props.bottom) this.props.bottom.value = this.canonical(this.inputs.bottom.value);
    }

    /* ----- Validierung ----- */

    buildValidSet() {
      this.validMap = {}; // normalisiert(lower) -> kanonischer Wert
      if (!this.datalist) return;
      Array.from(this.datalist.querySelectorAll('option')).forEach((o) => {
        var v = (o.value || '').trim();
        if (v) this.validMap[v.toLowerCase()] = v;
      });
    }

    norm(s) {
      return (s || '').trim();
    }

    isValid(s) {
      return Object.prototype.hasOwnProperty.call(this.validMap, this.norm(s).toLowerCase());
    }

    canonical(s) {
      var key = this.norm(s).toLowerCase();
      return this.validMap[key] || this.norm(s);
    }

    submitButton() {
      return document.getElementById('ProductSubmitButton-' + this.sectionId);
    }

    setWarn(msg) {
      if (this.warnEl) this.warnEl.textContent = msg || '';
    }

    applyValidation() {
      var btn = this.submitButton();
      if (this.mode !== 'bi') {
        this.setWarn('');
        return; // Einfarbig: Dawn steuert den Button
      }
      var t = this.norm(this.inputs.top.value);
      var b = this.norm(this.inputs.bottom.value);
      var okT = this.isValid(t);
      var okB = this.isValid(b);
      var same = okT && okB && this.canonical(t).toLowerCase() === this.canonical(b).toLowerCase();

      this.inputs.top.classList.toggle('bicolor__input--bad', (t !== '' && !okT) || same);
      this.inputs.bottom.classList.toggle('bicolor__input--bad', (b !== '' && !okB) || same);

      if (okT && okB && !same) {
        this.setWarn('');
        if (btn) btn.removeAttribute('disabled');
      } else {
        if (same) {
          this.setWarn('Bitte zwei unterschiedliche Farben wählen. Für eine einfarbige Brille oben auf „Einfarbig" wechseln.');
        } else {
          this.setWarn('Bitte gültige Codes für beide Farben eingeben.');
        }
        if (btn) btn.setAttribute('disabled', 'disabled');
      }
    }

    /* ----- Chips (kosmetisch, aus vorhandenem Swatch) ----- */

    updateChips() {
      ['top', 'bottom'].forEach((k) => {
        var chip = this.chips[k];
        if (!chip) return;
        var code = this.norm(this.inputs[k].value);
        var bg = code && this.isValid(code) ? this.swatchBackground(this.canonical(code)) : '';
        chip.style.background = bg || '';
      });
    }

    markSelectedSwatches() {
      ['top', 'bottom'].forEach((k) => {
        var wrap = this.swatchWraps && this.swatchWraps[k];
        if (!wrap) return;
        var code = this.canonical(this.norm(this.inputs[k].value)).toLowerCase();
        Array.from(wrap.querySelectorAll('.bicolor__swatch')).forEach((b) => {
          var on = (b.dataset.code || '').toLowerCase() === code && code !== '';
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', String(on));
        });
      });
    }

    swatchBackground(value) {
      var radio = this.findRadioByValue(value);
      var vs = this.variantSelects;
      if (!radio || !vs) return '';
      var sw = vs.querySelector('label[for="' + radio.id + '"] .swatch');
      if (!sw) return '';
      var cssVar = getComputedStyle(sw).getPropertyValue('--swatch--background');
      if (cssVar && cssVar.trim()) return cssVar.trim();
      return getComputedStyle(sw).backgroundColor || '';
    }

    /* ----- 194-Vorschau ----- */

    colorPreview() {
      return (this.productInfo || document).querySelector('color-preview-194');
    }

    updatePreview() {
      var p = this.colorPreview();
      if (!p) return;
      if (this.mode === 'bi') {
        if (typeof p.setBicolor === 'function') {
          p.setBicolor(this.canonical(this.inputs.top.value), this.canonical(this.inputs.bottom.value));
        }
      } else if (typeof p.setSingle === 'function') {
        p.setSingle(this.savedSingleValue);
      }
    }

    /* ----- Sammel-Update ----- */

    updateFromInputs() {
      this.updateChips();
      this.updateProps();
      this.applyValidation();
      this.updatePreview();
      this.markSelectedSwatches();
    }
  }

  window.customElements.define('bicolor-config', BicolorConfig);
})();
